import React, { useState, useEffect } from 'react';
import { useLoadBingMapScript } from 'hooks/useLoadBingMapScript';
import EVMap from 'components/ChargingLocator/EVMap/EVMap';
import EVLocateMe from 'components/ChargingLocator/EVLocateMe/EVLocateMe';
import EVCutline from 'components/ChargingLocator/EVMap/EVCutline';
import EVFilters from 'components/ChargingLocator/EVFilters/EVFilters';
import ChargingLocatorPanel from 'components/ChargingLocator/ChargingLocatorPanel/ChargingLocatorPanel';
import {
  IChargingStation,
  IEVChargingPageContent,
  IStationFilter,
} from 'interfaces/chargingLocator';
import { useZipcodeData } from 'hooks/useZipcodeData';
import './ChargingLocatorContainer.scss';
import useZipcode from 'hooks/useZipcode';

const bingMapScriptUrl = `https://www.bing.com/api/maps/mapcontrol?key=Ajkz_KnsjHxsfhRJeU78Xc8VgxAssv1iCF4leVVvmJLsPCaSXPaHdxuljT7aQ059`;

interface IChargingLocatorContainer {
  stations: IChargingStation[];
  pageContent: IEVChargingPageContent;
}

const ChargingLocatorContainer = ({
  stations,
  pageContent,
}: IChargingLocatorContainer): JSX.Element => {
  const [filters, setFilters] = useState<IStationFilter[]>([]);
  const [filteredStations, setFilteredStations] = useState<IChargingStation[]>(
    []
  );
  const [selectedStation, setSelectedStation] = useState<
    IChargingStation | undefined
  >(undefined);

  const bingMapScriptStatus = useLoadBingMapScript(bingMapScriptUrl);
  const { zipcode } = useZipcode();
  const { coordinates } = useZipcodeData(zipcode, 'Error');

  useEffect(() => {
    // initializing zipgate in case the zipcode is not available.
    if (pageContent) {
      const filterList: IStationFilter[] = [];
      (pageContent.filters || []).forEach((filterGroup) => {
        filterGroup.items.forEach((element: IStationFilter) => {
          const filter = structuredClone(element);
          filter.codeList = filter.codes.map((code) => code.code);
          filter.isSelected = false;
          filterList.push(filter);
        });
      });
      setFilters(filterList);
    }
  }, [pageContent]);

  useEffect(() => {
    if (stations) {
      const activeFilters = filters.filter((filter) => filter.isSelected);
      if (activeFilters.length > 0) {
        const matchingStations = stations.filter((station) => {
          var matchFlag = activeFilters.some((filter) => {
            if (filter.codeList?.includes('EVAPP') && station.isAcuraEvApp) {
              return true;
            }
            const codeMatch = (station.attributeCodeList || []).filter(
              (element) => (filter.codeList || []).includes(element)
            );
            if (codeMatch.length > 0) {
              return true;
            }
            return false;
          });

          return matchFlag;
        });
        setFilteredStations(matchingStations);
      } else {
        setFilteredStations(stations);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, stations]);

  const handleFilterChange = (selectedFilter: IStationFilter) => {
    const filtersCodes = selectedFilter.codes;
    const updatedFilters = [...(filters as IStationFilter[])];
    updatedFilters.forEach((filter) => {
      if (filter.codes === filtersCodes) {
        filter.isSelected = !filter.isSelected;
      }
    });
    setFilters([...updatedFilters]);
  };

  return (
    <div className="charging-locator-container">
      {bingMapScriptStatus === 'ready' && (
        <EVMap
          labels={{}}
          stations={filteredStations}
          isEmbedded={false}
          coordinates={coordinates}
          isCustomPins={true}
          handleStationChange={setSelectedStation}
          selectedStation={selectedStation}
        />
      )}
      <ChargingLocatorPanel
        stations={filteredStations}
        selectedStation={selectedStation}
        handleStationChange={setSelectedStation}
        pageContent={pageContent}
      />
      <EVFilters filters={filters} onFilterChange={handleFilterChange} />
      <EVLocateMe />
      <div className="charging-locator-container__legend">
        <EVCutline cutlineText={pageContent.labels.cutline} />
      </div>
    </div>
  );
};

export default ChargingLocatorContainer;
